export const labels = {
  es: {
    name: "Nombre",
    lastName: "Apellido",
    motherName: "Apellido materno",
    gender: "Género",
    countryOfBirth: "País de nacimiento",
    birthDate: "Fecha de Nacimiento",
    civilStatus: "Estado civil",
    educationLevel: "Nivel educativo alcanzado",
    dependants: "Cantidad de personas a cargo",
    mobilePhone: "Número de teléfono móvil",
    homePhone: "Teléfono de casa",
    workPhone: "Teléfono comercial",
    email: "Correo electrónico",
    addressesSameAsFirstHolders: "La dirección coincide con la del titular 1",
    taxAddresses: {
      country: "País",
      fullAddress: "Dirección fiscal",
      zipCode: "Código postal",
      city: "Ciudad",
      state: "Estado / Provincia",
      floor: "Piso",
      apartment: "Departamento",
    },
    postalAddressDifferent: "Es diferente a mi domicilio fiscal",
    postalAddresses: {
      country: "País",
      fullAddress: "Dirección postal",
      zipCode: "Código postal",
      city: "Ciudad",
      state: "Estado / Provincia",
      floor: "Piso",
      apartment: "Departamento",
    },
    proofOfAddress: "Comprobante de domicilio",
  },

  en: {
    name: "Name",
    lastName: "Surname",
    motherName: "Mother's Maiden Name",
    gender: "Gender",
    countryOfBirth: "Birth Country",
    birthDate: "Date of Birth",
    civilStatus: "Marital Status",
    educationLevel: "Highest Level of Education",
    dependants: "Number of dependants",
    mobilePhone: "Mobile Phone Number",
    homePhone: "Home Phone",
    workPhone: "Business Phone",
    email: "Email Address",
    addressesSameAsFirstHolders: "The address matches first holder's",
    taxAddresses: {
      country: "Country",
      fullAddress: "Tax Address",
      zipCode: "Postal Code",
      city: "City",
      state: "State / Province",
      floor: "Floor",
      apartment: "Department",
    },
    postalAddressDifferent: "It is different from my tax address",
    postalAddresses: {
      country: "Country",
      fullAddress: "Mailing Address",
      zipCode: "Postal Code",
      city: "City",
      state: "State / Province",
      floor: "Floor",
      apartment: "Department",
    },
    proofOfAddress: "Proof of Address",
  },
};

export const title = {
  es: "Información personal",
  en: "Personal Information",
};

export const texts = {
  es: {
    prefix: "Sección",
    section1: "Datos básicos",
    section2: "Contacto",
    section3: "Domicilio fiscal",
    section3SubsecuentHolders:
      "Domicilio fiscal (si es diferente a la del primer titular)",
    section4: "Domicilio postal (si es diferente al fiscal)",
    section5: "Comprobante de domicilio",
  },

  en: {
    prefix: "Section",
    section1: "Basic Information",
    section2: "Contact Information",
    section3: "Legal Address",
    section3SubsecuentHolders:
      "Legal Address (if different from first holder's)",
    section4: "Mailing Address (if different from tax address)",
    section5: "Proof of Address",
  },
};

export const placeholders = {
  es: {
    name: "ej. José Luis",
    lastName: "ej. Rodriguez",
    motherName: "ej. Esquivel",
    gender: "Seleccioná una opción",
    countryOfBirth: "Seleccioná una opción",
    birthDate: "DD/MM/AAAA",
    civilStatus: "Seleccioná una opción",
    educationLevel: "Seleccioná una opción",
    dependants: "Seleccioná una opción",
    email: "ej. johnsmith@gmail.com",
    taxAddresses: {
      country: "Seleccioná una opción",
      fullAddress: "Calle y número",
      zipCode: "Ej. 1426",
      city: "ej. CABA",
      state: "Ej. Buenos Aires",
      floor: "Ej. 1",
      apartment: "Ej. A",
    },
    postalAddresses: {
      country: "Seleccioná una opción",
      fullAddress: "Calle y número",
      zipCode: "Ej. 1426",
      city: "ej. CABA",
      state: "Ej. Buenos Aires",
      floor: "Ej. 1",
      apartment: "Ej. A",
    },
  },

  en: {
    name: "e.g. José Luis",
    lastName: "e.g. Rodriguez",
    motherName: "e.g. Esquivel",
    gender: "Select an option",
    countryOfBirth: "Select an option",
    birthDate: "DD/MM/YYYY",
    civilStatus: "Select an option",
    educationLevel: "Select an option",
    dependants: "Select an option",
    email: "e.g. johnsmith@gmail.com",
    taxAddresses: {
      country: "Select an option",
      fullAddress: "Street and Number",
      zipCode: "e.g. 1426",
      city: "e.g. CABA",
      state: "e.g. Buenos Aires",
      floor: "e.g. 1",
      apartment: "e.g. A",
    },
    postalAddresses: {
      country: "Select an option",
      fullAddress: "Street and Number",
      zipCode: "e.g. 1426",
      city: "e.g. CABA",
      state: "e.g. Buenos Aires",
      floor: "e.g. 1",
      apartment: "e.g. A",
    },
  },
};

export const tooltips = {
  es: {
    proofOfAddress:
      "Puede ser una factura de un servicio con la misma dirección que se ingresó anteriormente. El comprobante de domicilio no debe superar los 3 meses de antiguedad",
      dependantsTooltip: 
      "Familiares u otras personas bajo tu responsabilidad o cuidado."
  },
  en: {
    // NOTE: I'm not sure "receipt" or "service" are the correct terminology here
    proofOfAddress:
      "Could be a receipt for a service issued to the same address you entered previously. The proof of adress cannot be older than 3 months.",
    dependantsTooltip: 
      "Family members or other people under your care or responsability"
  },
};
